module.exports = __webpack_public_path__ + "static/media/batch-onboarding-method.28ed0fd1.jpg";